import { createContext, useContext } from "react";

export type SessionRefreshCallbacks = {
  onCompleted: () => void;
  onError: () => void;
};

const SessionRefreshContext = createContext<
  ((callbacks: SessionRefreshCallbacks) => void) | null
>(null);

export const SessionRefreshProvider = SessionRefreshContext.Provider;

export const useRequestSessionRefresh = () => {
  const requestSessionRefresh = useContext(SessionRefreshContext);

  if (!requestSessionRefresh) {
    throw new Error(
      "useRequestSessionRefresh must be used within SessionRefreshProvider"
    );
  }

  return requestSessionRefresh;
};
